import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../utils/queryKeys';

export function useFooter() {
  const { data: currentYear } = useQuery({
    queryKey: queryKeys.footer.all,
    queryFn: () => new Date().getFullYear(),
    // Los datos nunca se vuelven stale durante la sesión
    staleTime: Infinity,
    // Mantener en caché durante toda la sesión
    cacheTime: Infinity,
    // No refetch en focus ya que el año no cambiará durante la sesión
    refetchOnWindowFocus: false
  });

  return {
    currentYear: currentYear || new Date().getFullYear(),
  };
}